import React, { useEffect, useState } from 'react';
import driverApi from '../../../clients/DriverClient';
import { useBookingContext } from '../BookingContext';
import { useAuth } from '../../../context/AuthContext';
import ButtonSelect from '../../shared/ButtonSelect';
import { formatLocation } from '../../../utils/bookingUtils';
import { resolvePreferredLocation } from '../../../utils/preferredLocation';
import { normalizeLocationKey } from '../../../clients/locationApiBase';

const LocationSection: React.FC = () => {
  const { booking, updateBooking } = useBookingContext();
  const { user } = useAuth();
  const [locations, setLocations] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadLocations = async () => {
      setIsLoading(true);
      setError('');
      try {
        const result = await driverApi.getBookingLocations();

        setLocations(result);
        if (!booking.location && result.length > 0) {
          // preferredLocation may be stored in a different format than the option
          // strings (a key like "tustin" vs the "Tustin" option, or spacing
          // differences). Match on a normalized key so the venue still resolves,
          // then store the actual option string — ButtonSelect highlights by strict
          // ===, so we must hand it a value that equals one of `result`. The
          // entitlement flow normalizes the same way; this keeps the two in step.
          const initial = resolvePreferredLocation(
            user?.preferredLocation,
            (c) => result.some((loc) => normalizeLocationKey(loc) === normalizeLocationKey(c)),
          );
          if (initial) {
            const matched = result.find(
              (loc) => normalizeLocationKey(loc) === normalizeLocationKey(initial),
            );
            if (matched) updateBooking({ location: matched });
          }
        }
      } catch (e) {
        setError('Failed to load locations');
      } finally {
        setIsLoading(false);
      }
    };

    loadLocations();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
      <div className="mb-3">
       <ButtonSelect
        options={locations}
        selected={booking.location}
        onChange={(location) => updateBooking({ location })}
        disabled={isLoading}
        title="Locations:"
        renderLabel={formatLocation}
       />
        {error && <div className="text-danger mt-2">{error}</div>}
      </div>
  );
};

export default LocationSection;
